/**
 * Service conditions (company.voorwaarden.service) shared by the customer
 * bestek page and the backend check on confirm.
 */

const normalizeServiceConditionsLang = (lang) => {
  const raw = String(lang || "nl").toLowerCase();
  if (raw.startsWith("fr")) return "fr";
  if (raw.startsWith("en")) return "en";
  return "nl";
};

/**
 * Pick HTML from a lang map (nl/fr/…) for the active language.
 * Falls back: exact lang → nl → first non-empty string value.
 */
const pickServiceConditionsHtml = (serviceConditions, lang) => {
  if (!serviceConditions) return null;
  if (typeof serviceConditions === "string") {
    const html = serviceConditions.trim();
    return html || null;
  }
  if (typeof serviceConditions !== "object") return null;

  const preferred = normalizeServiceConditionsLang(lang);
  const candidates = [
    serviceConditions[preferred],
    serviceConditions.nl,
    serviceConditions.NL,
    ...Object.values(serviceConditions),
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return null;
};

/**
 * Prefer company.voorwaarden.service.nl|fr (top-level, not under info).
 * Tolerates typo "voorwarden". Falls back to info.serviceConditions.
 */
const resolveServiceConditionsMap = (dossierData) => {
  if (!dossierData || typeof dossierData !== "object") return null;
  const voorwaardenRoot =
    dossierData.voorwaarden || dossierData.voorwarden || null;
  const fromVoorwaarden =
    voorwaardenRoot?.service ||
    (typeof voorwaardenRoot?.nl === "string" ||
    typeof voorwaardenRoot?.fr === "string"
      ? voorwaardenRoot
      : null);
  return fromVoorwaarden || dossierData.info?.serviceConditions || null;
};

/** True when the dossier shows service conditions the customer must accept. */
const hasServiceConditions = (dossierData) =>
  Boolean(
    pickServiceConditionsHtml(resolveServiceConditionsMap(dossierData), "nl")
  );

module.exports = {
  normalizeServiceConditionsLang,
  pickServiceConditionsHtml,
  resolveServiceConditionsMap,
  hasServiceConditions,
};
